import { GetConfiguration } from "../utils/config";
import Auth, { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { handleErrorsForSSO, getHeadersForSSO } from './identityService';
import { TelematicoData, LoadTelematico } from '../types/types';
import { Telematico, TelematicoSearchModel } from "../models/telematico";
import { ContentFromTelematico } from "../models/contentFromTelematico";

export const importTelematico = (ip: string, authData: AuthDataType, user: User, metadata: TelematicoData, file: File) => {
    //Create body
    const formData = new FormData();
    // files.forEach(file => {
    // console.log('Aggiungo il file 1 avente tipo: ' + file.type)
    // console.log('Aggiungo il file 1 strigyfato: ' + JSON.stringify(file))
    formData.append('file', file);
    formData.append('metadata', JSON.stringify(metadata));
    // });
    // console.log('Aggiungo il file 1 avente lunghezza: ' + file.size)
    // console.log('Aggiungo il file 1 strigyfato: ' + JSON.stringify(file))
    // formData.append('files', file);
    // formData.append('metadata', JSON.stringify(company));
    const url = `${GetConfiguration().api_url}/telematico/upload`
    console.log('Telematico upload', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForUpload(ip, user),
        body: formData
    })
    .then(res => handleErrorsForSSO(res))
    .then(res => res.json())
    .then(json => {
        console.log(`Telematico ("${authData.user}") -> letti ${json.length} files`);
        // console.log('Import ritorna: ' + JSON.stringify(json));
        const rv = (json as boolean);
        console.log('Telematico eseguito con esito: ' + rv);
        return rv;
    })
    .catch(error => {
        console.log('Import error:', error);
        throw error;
    });
        
    // return fetch(`${this.endpoint}/upload`, options)
    //     .then<Documento[]>(this.asJson)
    //     .then(list => EntityUtils.assignList(list, Documento));
        // Qualora Upload avesse il riferimento ai documenti caricati
        // una volta modificato il server usiamo quanto sotto 
        // .then<Upload>(this.asJson)
        // .then(item => EntityUtils.assignItem(item, Upload))
}

function getHeadersForUpload(ip: string, user: User): Headers {

    const headers = new Headers();
    // headers.append('Accept', 'application/json');
    // headers.append('Content-Type', 'multipart/form-data');
    // headers.append('Access-Control-Allow-Origin', '*');
    headers.append('IP', ip);
    
    headers.append("Authorization", `Bearer ${user.access_token}`);
    return headers;
}

export const getTelematicos = (ip: string, authData: AuthDataType, user: User, model: TelematicoSearchModel): Promise<Telematico[]> => {
        
    console.log('getTelematicos body data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/telematico/search`
    console.log('getTelematicos', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getTelematicos ("${authData.user}") -> letti ${json.length} telematicos`);
            // console.log('getTelematicos recuperato json: ' + JSON.stringify(json));
            const rv = (json as Telematico[]);
            console.log('getTelematicos recuperate: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('getTelematicos error:', error);
            throw error;
        });
}


/// Funzione that laod data from bpoint in forfetario
export const loadDatiFromTelematicos = (ip: string, authData: AuthDataType, user: User, model: LoadTelematico): Promise<ContentFromTelematico> => {
        
    console.log('LoadTelematicos body data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/telematico/load`
    console.log('LoadTelematicos', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`LoadTelematicos ("${authData.user}") -> letti ${json.length} telematicos`);
            // console.log('getTelematicos recuperato json: ' + JSON.stringify(json));
            const rv = (json as ContentFromTelematico);
            console.log('LoadTelematicos recuperate: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('LoadTelematicos error:', error);
            throw error;
        });
}


